import VueGtag from "vue-gtag";
import { MONITOR_ENV } from "@/constants/env";
/* 

    google analytics


*/

export default function setup() {
  const GOOGLE_TAG_ID = "gatag";

  if (!MONITOR_ENV) return;

  const isExist = document.getElementById(GOOGLE_TAG_ID);

  if (!isExist) {
    // GA 연결 태그
    const connetScript = document.createElement("script");
    connetScript.setAttribute("id", GOOGLE_TAG_ID);
    connetScript.setAttribute("async", "");
    connetScript.setAttribute(
      "src",
      "https://www.googletagmanager.com/gtag/js?id=UA-155005070-1"
    );

    // GA 실행 태그
    const executeScript = document.createElement("script");
    executeScript.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-155005070-1');
    `;

    document.head.appendChild(connetScript);
    document.head.appendChild(executeScript);
  }
}
